export const SsNumberFirstValues = ['1', '2', '3', '4', '7', '8'];
export const Months = ['01', '02', '03', '04', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
export const DomainToScope = {
    'front-souscription': 'SouscriptionEmployeur',
    'front-affiliation-employeur': 'AffiliationEmployeur',
    'front-espace-employeur': 'EspaceEmployeur',
    'front-affiliation': 'AffiliationSalarie',
    '': 'EspaceAdherent',
    'front-care': 'BoCare',
    souscription: 'SouscriptionEmployeur',
    employeur: 'EspaceEmployeur',
    'affiliation-employeur': 'AffiliationEmployeur',
    affiliation: 'AffiliationSalarie',
    care: 'BoCare'
};
export const CommonPageName = {
    GoBack: -1,
    Home: '/',
    Login: '/login',
    ResetPassword: '/reset-password',
    Forbidden: '/forbidden',
    NotFound: '/not-found',
    Contact: '/contact'
};
export const UnbreakableSpace = '\xa0';
export const LcBearerKey = 'lc-bearer';
export const LcRefreshBearerKey = 'lc-refresh-bearer';
export const ageMax = 150;
export const MIN_AGE_EMANCIPATION = 16;
export const MAX_AGE_EMANCIPATION = 18;
export const AGE_LIMITE_ADULT_TEETH = 13;
export const AGE_ADULT = 18;
